import { createUseStyles } from "react-jss";
import * as Mixins from "../../theme/Mixins";

const buttonIconSize = (size) => {
    if (typeof size === "number") return size;
    return size === "small" ? 16 : 24;
};

export default createUseStyles({
    button: {
        alignItems: "center",
        background: ({ theme }) => Mixins.alpha(theme.ButtonBackground, theme.ControlAlpha),
        borderRadius: ({ theme }) => theme.BorderRadius,
        boxShadow: ({ theme }) => `0 0 0 ${theme.BorderWidth}px ${theme.ControlBorderColor} inset`,
        boxSizing: "border-box",
        color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.buttonBackgroundColor(theme)),
        composes: "button",
        cursor: "pointer",
        display: "flex",
        fontWeight: 700,
        justifyContent: "center",
        minHeight: ({ theme }) => theme.InputHeight + theme.BorderWidth * 2,
        outline: "none",
        padding: 6,
        transition: "background 200ms, box-shadow 200ms, color 200ms",
        userSelect: "none",
        fontFamily: ({ theme }) => `"${theme.TextFont}", sans-serif`,
        "font-size": "16px",
        "line-height": "25.7778px",
    },
    buttonActive: {
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.PrimaryColor),
        background: ({ theme }) => theme.PrimaryColor,
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.BorderWidth}px ${Mixins.darken(theme.PrimaryColor, 0.5)} inset`,
    },
    buttonHidden: {
        composes: "button--hidden",
        visibility: "hidden",
    },
    buttonDisabled: {
        composes: "button--disabled",
        opacity: 0.7,
        pointerEvents: "none",
    },
    buttonSmall: {
        composes: "button--small",
        fontSize: 13,
        fontWeight: "initial",
        margin: [[0, 6]],
        padding: [[6, 12]],
    },
    buttonLarge: {
        composes: "button--large",
        flexBasis: 180,
        margin: [[12, 6]],
        padding: [[12, 12]],
    },
    buttonFull: {
        composes: "button--full",
        margin: [[27, 0]],
        padding: [[12, 12]],
    },
    buttonFlex: {
        composes: "button--flex",
        flex: 1,
        margin: [[12, 6]],
        padding: [[12, 12]],
    },
    buttonTextContainer: {
        composes: "button__text",
    },
    buttonBorderNone: {
        border: "none",
    },
    buttonTextAnimated: {
        transition: "transform 200ms ease-in-out",
    },
    buttonTextAnimatedHover: {
        transform: ({ iconPosition }) =>
            `translate(${iconPosition === "start" ? "13px" : "-13px"})`,
    },
    buttonIconContainer: {
        composes: "button__container",
        height: ({ size }) => `${buttonIconSize(size)}px`,
        lineHeight: ({ size }) => `${buttonIconSize(size)}px`,
        marginLeft: ({ iconPosition, iconOnHover, textAndIcon }) =>
            iconPosition === "end" && textAndIcon && !iconOnHover ? 10 : 0,
        marginRight: ({ iconPosition, iconOnHover, textAndIcon }) =>
            iconPosition === "start" && textAndIcon && !iconOnHover ? 10 : 0,
        pointerEvents: "none",
        position: "relative",
        verticalAlign: "middle",
    },
    buttonIcon: {
        composes: "button__icon",
        fontSize: ({ size }) => buttonIconSize(size),
        width: ({ size }) => buttonIconSize(size),
        left: ({ iconPosition, iconOnHover, textAndIcon }) =>
            iconPosition === "start" && textAndIcon && !iconOnHover ? 0 : -12,
        position: ({ iconOnHover, textAndIcon }) =>
            textAndIcon && iconOnHover ? "absolute" : "initial",
        right: ({ iconPosition, iconOnHover, textAndIcon }) =>
            iconPosition === "end" && textAndIcon && !iconOnHover ? 0 : -12,
        textAlign: "center",
    },
    buttonIconAnimated: {
        opacity: 0,
        transform: ({ iconPosition }) => `translate(${iconPosition === "start" ? "5px" : "-5px"})`,
        transition: "transform 200ms ease-in-out, opacity 200ms ease-in-out",
    },
    buttonIconAnimatedHover: {
        opacity: 1,
        transform: ({ iconPosition }) => `translate(${iconPosition === "start" ? "-8px" : "8px"})`,
    },
    buttonIconDisabled: {
        composes: "button__icon--disabled",
    },
    pointer: {
        cursor: "pointer",
    },
});
